
import SellMyCarHeroArea from '@/components/modules/SellMyCarHeroArea'
import Motorway from '@/components/modules/Motorway'
export default {
    components: {
        SellMyCarHeroArea,
        Motorway
    },
    head() {
        return {
            title: "CheckMot.com | Sell my car | Compare Offers Online",
            meta: [
            {
                hid: 'og:title',
                property: 'og:title',
                content: "CheckMot.com | Sell my car | Compare Offers Online"
            },
            {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: "CheckMot.com | Sell my car | Compare Offers Online"
            },
            ],
        }
    },
}
